/**
 * 站外超链接统一新标签页打开。
 *
 * 站内路由（router-link / 相对路径 / 同源绝对地址）保持本页跳转；
 * 只要 href 是 http(s) 且 trace 到别的域名，就拦截本页导航改成新窗口打开。
 *
 * 富文本是 v-html 直接插进 DOM 的，模板里加不了 target，所以这里用
 * MutationObserver 补属性 + 全局点击兜底，两层都能覆盖。
 */
const SITE_HOSTS = ['shujuzichan.com', 'www.shujuzichan.com']

/** 站内文件（PDF/Office 等）也算“外开”，不然会在当前页把 SPA 顶掉 */
const FILE_EXT = /\.(pdf|docx?|xlsx?|pptx?|zip|rar|7z|txt|csv)(\?|#|$)/i

function isExternalHref(href) {
  if (!href) return false
  const raw = String(href).trim()
  if (!/^https?:\/\//i.test(raw)) return false
  try {
    const url = new URL(raw, window.location.href)
    if (FILE_EXT.test(url.pathname)) return true
    if (url.origin === window.location.origin) return false
    return !SITE_HOSTS.includes(url.hostname)
  } catch (e) {
    return false
  }
}

function markAnchor(anchor) {
  const href = anchor.getAttribute('href')
  if (!isExternalHref(href)) return
  if (anchor.getAttribute('target') !== '_blank') anchor.setAttribute('target', '_blank')
  const tokens = new Set((anchor.getAttribute('rel') || '').split(/\s+/).filter(Boolean))
  tokens.add('noopener')
  tokens.add('noreferrer')
  anchor.setAttribute('rel', Array.from(tokens).join(' '))
}

function scan(root) {
  if (!root || root.nodeType !== 1) return
  if (root.tagName === 'A') markAnchor(root)
  const list = root.querySelectorAll ? root.querySelectorAll('a[href]') : []
  list.forEach(markAnchor)
}

export function setupExternalLinks() {
  if (typeof document === 'undefined') return

  scan(document)
  const observer = new MutationObserver((records) => {
    records.forEach((record) => {
      record.addedNodes.forEach((node) => scan(node))
    })
  })
  observer.observe(document.body, { childList: true, subtree: true })

  // 兜底：某些富文本链接是运行时才拿到 href，或用户用键盘激活
  document.addEventListener(
    'click',
    (event) => {
      const anchor = event.target && event.target.closest ? event.target.closest('a[href]') : null
      if (!anchor) return
      if (!isExternalHref(anchor.getAttribute('href'))) return
      if (event.defaultPrevented) return
      event.preventDefault()
      window.open(anchor.getAttribute('href'), '_blank', 'noopener,noreferrer')
    },
    true,
  )
}
